import APIController from '../core-api-controller';

export const getPresignedUrlApi = (obj = {}) => {
  const path = `${APIController.endpointApi}/attachments/presigned_url`;
  return APIController.postCallback(path, obj);
};

export const getExternalPresignedUrlApi = (obj = {}, token = process.env.REACT_APP_EXTERNAL_AUTH_TOKEN) => {
  const path = `${APIController.endpointApi}/external/attachments`;
  return APIController.postExternalCallback(path, obj, null, token);
};

export const fetchAttachmentApi = (id = '') => {
  const path = `${APIController.endpointApi}/attachments/${id}`;
  return APIController.getApiCallback(path);
};

export const removeLabDocumentApi = (id = '') => {
  const path = `${APIController.endpointApi}/attachments/${id}/remove_lab_document`;
  return APIController.deleteCallback(path);
};
